import { useEffect } from "react";
import MainContainer from "../../components/container/MainContainer";
import LocationHeader from "../../components/header/LocationHeader";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import AddCommunity from "./AddCommunity";
import Table from "../../components/tables/Table";
import {
  getCommunities,
  unsetCommunity,
} from "../../features/communitiesSlice";
import Loading from "../../components/loading/Loading";
import { useAuthorization } from "../../hooks/useAuthorization";
import { useLocation } from "react-router-dom";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";

const Community = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const communities = useSelector((state) => state.communities.data);
  const total = useSelector((state) => state.communities.total);
  const loading = useSelector((state) => state.communities.load.getCommunities);
  const { isAuthorized } = useAuthorization();

  const title = "Communities";
  // const links = [{ to: "/countries", name: "Countries" }];

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Community" },
    { id: "email", text: "Email" },
    { id: "organization", text: "Country" },
    { id: "country", text: "Nation" },
  ];

  const onPageChange = async (limit, offset) => {
    try {
      await dispatch(getCommunities({ limit, offset }));
    } catch (error) {}
  };

  const openCommunityModal = () => {
    dispatch(openModal(<AddCommunity />));
  };

  useEffect(() => {
    dispatch(getCommunities());
    return () => {
      dispatch(unsetCommunity());
    };
  }, []);

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer>
        <LocationHeader
          title={title}
          links={[]}
          action={openCommunityModal}
          authorized={isAuthorized("communities", "create")}
        />
        <PaginationSecondBar
          loading={loading}
          onPageChange={onPageChange}
          total={total}
        />
        <main className="table-container">
          <Table columns={columns} data={communities} loading={loading} link />
        </main>
      </MainContainer>
    </>
  );
};

export default Community;
